/**
 * @generated SignedSource<<7e6955d1a7c4801d30e917cc16a83306>>
 * @relayHash c67b40e0841cbe3641e147b8f635e291
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8cba7661cae04b18a2f396c25dedbd53d2bb4184aef34b7e93cfb70fbef58af5

import type { ConcreteRequest } from 'relay-runtime';
export type EditorPreferencesQuery$variables = Record<PropertyKey, never>;
export type EditorPreferencesQuery$data = {
  readonly userPreferences: {
    readonly confluenceEditorSettings: {
      readonly toolbarDockingInitialPosition: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type EditorPreferencesQuery = {
  response: EditorPreferencesQuery$data;
  variables: EditorPreferencesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "concreteType": "UserPreferences",
    "kind": "LinkedField",
    "name": "userPreferences",
    "plural": false,
    "selections": [
      {
        "concreteType": "ConfluenceEditorSettings",
        "kind": "LinkedField",
        "name": "confluenceEditorSettings",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "toolbarDockingInitialPosition"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "EditorPreferencesQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "EditorPreferencesQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "c67b40e0841cbe3641e147b8f635e291",
    "id": "8cba7661cae04b18a2f396c25dedbd53d2bb4184aef34b7e93cfb70fbef58af5",
    "metadata": {},
    "name": "EditorPreferencesQuery",
    "operationKind": "query",
    "text": "query EditorPreferencesQuery{userPreferences{confluenceEditorSettings{toolbarDockingInitialPosition}}}"
  }
};
})();

(node as any).hash = "49dd5f6cf6c26477ad455a4c7f501e60";

export default node;
